import {DispatchStatus, dispatchStatus} from "@ots-frontend/ots-data";
import {ReactNode} from "react";
import * as CSS from "csstype";
import {
  dispatchCanceledColor,
  dispatchCompletedColor,
  dispatchPendingColor,
  dispatchStartedColor,
  grayColor
} from "../theme/colors";
import {FaCheck, FaHourglassHalf, FaTimesCircle} from "react-icons/fa";

export const getDispatchStatusColor = (
  status: DispatchStatus
): CSS.Property.Color => {
  switch (status) {
    case dispatchStatus.pending:
      return dispatchPendingColor;
    case dispatchStatus.started:
      return dispatchStartedColor;
    case dispatchStatus.canceled:
      return dispatchCanceledColor;
    case dispatchStatus.completed:
      return dispatchCompletedColor;
    default:
      return grayColor;
  }
};

/**
 * Returns the icon react node for the dispatch status.
 *
 * @param status the status
 */
export const getDispatchStatusIcon = (
  status: DispatchStatus
): ReactNode | undefined => {
  switch (status) {
    case dispatchStatus.pending:
      return <FaHourglassHalf/>;
    case dispatchStatus.started:
      return <span className="iconify" data-icon="mdi-tanker-truck"></span>;
    case dispatchStatus.canceled:
      return <FaTimesCircle/>;
    case dispatchStatus.completed:
      return <FaCheck/>;
    default:
      return undefined;
  }
};

export const getDispatchStatusColorRef = (
  status: DispatchStatus,
  pickup = false
): string => {
  switch (status) {
    case dispatchStatus.pending:
      return "dispatch-pending";
    case dispatchStatus.started:
      if (pickup) {
        return "dispatch-pickedup";
      } else {
        return "dispatch-started";
      }
    case dispatchStatus.canceled:
      return "dispatch-canceled";
    case dispatchStatus.completed:
      return "dispatch-completed";
    default:
      return "black";
  }
};
